<template>
  <div class="aco-grid">
    <div class="aco-info-box">
      <order-filter/>
    </div>
    <div class="aco-details-box">
      <order-list/>
    </div>
  </div>
</template>

<script>
  import OrderFilter from './OrderFilter'
  import OrderList from './OrderList'

  export default {
    components: {
      orderFilter: OrderFilter,
      orderList: OrderList
    }
  }
</script>
